import { Injectable, inject } from '@angular/core';
import { ClubHubDataService } from '@shared/services/clubhub-data.service';
import { IEmbedConfig, IMiReport } from './mi-generic.model';

@Injectable({ providedIn: 'root' })
export class MiGenericService {
  private readonly dataService = inject(ClubHubDataService);

  public getReports(endpoint: string) {
    return this.dataService.get<IMiReport[]>(`powerbi/${endpoint}`);
  }

  public getReportConfiguration(reportId: string, endpoint: string) {
    return this.dataService.get<IEmbedConfig>(`powerbi/${endpoint}/${reportId}`);
  }
}
